import React from 'react';
interface SettingsSectionProps {
  id?: string;
  title: string;
  description?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}
export function SettingsSection({
  id,
  title,
  description,
  action,
  children
}: SettingsSectionProps) {
  const headingId = `${id ?? title.toLowerCase().replace(/\W+/g, '-')}-title`;
  return <section id={id} aria-labelledby={headingId} className="scroll-mt-6 border-t border-line py-7 first:border-t-0 first:pt-0" data-id="element-686" data-mp="1qzezoeepeka2">
      <div className="mb-4 flex items-start justify-between gap-4" data-id="element-687" data-mp="2jm9h12g853jb">
        <div data-id="element-688" data-mp="2jn10jewjrat8">
          <h2 id={headingId} className="text-lg font-bold" data-id="element-689" data-mp="2jk56w2rqf8al">
            {title}
          </h2>
          {description && <p className="mt-0.5 text-sm text-ink-3" data-id="element-690" data-mp="29o236sh8f1lj">{description}</p>}
        </div>
        {action}
      </div>
      {children}
    </section>;
}